/* Amend header right border style and use trah-alt icon Oct 22, 2026 */
<template>
  <div class="overflow-auto">
    <strong>Competitors Bids</strong>

    <b-container class="pl-0 ml-0">
      <b-form>
        <b-table
          id="competitorBids"
          table-class="resizable"
          thead-class="competitorBidsTable"
          sticky-header="700px"
          show-empty
          :empty-html="c_tableEmpty"
          small
          responsive
          select-mode="single"
          head-variant="light"
          :fields="d_competitorBidFields"
          :items="c_competitorBids"
          :style="{ 'min-width': c_tblMinWidth }"
          :per-page="d_perPage"
          :current-page="d_currentPage"
        >

          <!-- Competitor -->
          <template #cell(competitorId)="data">
            <b-form-select
              @click.stop
              v-model="data.item.competitorId"
			:options="d_competitors"
			class="styled-input"
			style="width:250px;"
			placeholder="Select Competitor"
            />
          </template>

          <!-- Bid Amount -->
          <template #cell(bidAmount)="data">
            <div class="d-flex">
             <b-input-group prepend="$">
              <b-form-input
                v-model="data.item.bidAmount"
                type="text"
				class="styled-input"
                style="width:120px;"
                :formatter="m_numberFormat"
              />
			 </b-input-group>
            </div>
          </template>

          <!-- Bid Position -->
          <template #cell(bidPosition)="data">
            <b-form-input
			v-model="data.item.bidPosition"
			type="number"
			class="styled-input"
			style="width:150px;"
            />
          </template>

          <!-- Winning Bid -->
		<template #cell(winningBid)="data">
			<b-form-radio-group
				v-model="data.item.winningBid"
			>
			<b-form-radio value="Yes">Yes</b-form-radio>
			<b-form-radio value="No">No</b-form-radio>
			</b-form-radio-group>
		</template>
          <!-- Delete -->
          <template #cell(delete)="data">
            <fa-icon
              icon="trash-alt"
			  size="xs"
              class="cursor-pointer text-danger"
              @click="m_handleRemoveClick(data.index)"
            />
          </template>

          <!-- Footer -->
          <template #custom-foot>
            <b-tr>
              <b-td>
                <b-dropdown
                  variant="outline-secondary"
                  dropup
                  :text="d_perPage.toString()"
                >
                  <b-dropdown-item
                    v-for="x in [5,10,25,50,100,150,200]"
                    :key="x"
                    @click="m_chgPgSize(x)"
                  >
                    {{ x }}
                  </b-dropdown-item>
                </b-dropdown>
                rows per page
              </b-td>

              <b-td>Total: {{ c_totalRows }}</b-td>
              <b-td></b-td>
              <b-td colspan="3"></b-td>

              <b-td>
                <b-pagination
                  v-model="d_currentPage"
                  align="right"
                  :total-rows="c_totalRows"
                  :per-page="d_perPage"
                />
              </b-td>
            </b-tr>
          </template>

        </b-table>

        <!-- Buttons -->
		<div class="btn-bar">
        <b-button
          class="btn-add btn-add-cl-item"
          variant="outline-primary"
          title="Add"
          @click="m_handleAddClick"
        >
          <fa-icon icon="plus" /> Add
        </b-button>

        <b-button
          class="btn-save"
          variant="outline-secondary"
          title="Save"
          @click="m_saveRows"
        >
          <fa-icon icon="save" /> Save
        </b-button>
		</div>

      </b-form>
    </b-container>
  </div>
</template>

<script src="@/utils/jQuery.resizableColumns.js"></script>

<script>
import { fn_saveCompetitorBids } from "@/utils/api.js";
import util, { kbdpAlert } from "@/utils/util.js";
import { Resize } from "vue-resizer";

export default {
  name: "CompetitorBids",
  components: { resize: Resize },
  inject: ["vcrec"],
  props: {
    p_recData: Array,
  },

  data() {
    return {
      d_currentPage: 1,
      d_perPage: 5,
      d_competitors: [],
      d_competitorBids: [],

      d_competitorBidFields: [
        { label: "Competitor", key: "competitorId", visible: true,thStyle:"width:200px;border-right1:0.1em solid #adb5bd;padding:0.1em;",thclass:"resizable" },
        { label: "Bid Amount", key: "bidAmount", visible: true,thStyle:"width:50px;border-right1:0.1em solid #adb5bd;padding:0.1em;",thclass:"resizable" },
        { label: "Bid Position", key: "bidPosition", visible: true,thStyle:"width:50px;border-right1:0.1em solid #adb5bd;padding:0.1em;",thclass:"resizable" },
        { label: "Winning Bid", key: "winningBid", visible: true,thStyle:"border-right1:0.1em solid #adb5bd;padding:0.1em;",thclass:"resizable" },
        { label: "Delete", key: "delete", visible: true,thStyle:"border-right1:0.1em solid #adb5bd;padding:0.1em;",thclass:"resizable" },
      ],
	  d_initialCompetitorBids:[],
    };
	
  },

  created()  {
  
   this.d_competitorBids = Array.isArray(this.p_recData.competitorBids)
      ? [...this.p_recData.competitorBids.map(c=>{return {...c,bidAmount:c.bidAmount.toLocaleString("en-US")};})]
      : [];

    this.d_competitors = Array.isArray(this.p_recData.competitors)
      ? this.p_recData.competitors.map(c=>{return {text:c.competitorName,value:c.competitorId};})
      : [];
  
	this.d_competitors.unshift({ text: "Select Competitor", value: null, disabled: true });
	
	if (this.d_competitorBids && this.d_competitorBids.length === 0) {
      this.m_handleAddClick();
    }
	
	this.m_initialData();
	
  },
  mounted() {
    this.m_initResizable();
  },
  
  beforeRouteLeave(to, from, next) {
     console.log('In beforeRouteLeave');
	},
  computed: {
    c_totalRows() {
      return this.c_competitorBids.length;
    },

    c_competitorBids() {
      return this.d_competitorBids.filter(r => !r.removed);
    },

    c_tableEmpty() {
      return `<span><b>No records.</b></span>`;
    },

    c_tblMinWidth() {
      const visible = this.d_competitorBidFields.filter(f => f.visible).length;
      return visible < 4 ? null : `${visible * 200}px`;
    },

	c_dataChanged() {
		const a = JSON.stringify(this.d_initialCompetitorBids);
		const b = JSON.stringify(this.d_competitorBids);
		return a !== b
	}



  },
  watch: {
  c_dataChanged(nv){
		if(nv) window.sessionStorage.setItem('unsaved-changes', true);
	},
  p_recData(nv) {
    if (!nv) {
      this.d_competitorBids = [];
      this.d_competitors = [];
      this.m_handleAddClick();
      return;
    }

    this.d_competitorBids = Array.isArray(nv.competitorBids)
      ? [...nv.competitorBids]
      : [];

    this.d_competitors = Array.isArray(nv.competitors)
      ? nv.competitors.map(c=>{return {text:c.competitorName,value:c.competitorId};})
      : [];

   
  }
},
  methods: {
    m_initResizable() {
      const table = document.getElementById("competitorBids");
      if (!table) return;

      const headers = table.querySelectorAll("th");
      headers.forEach((header, index) => {
        header.style.position = "relative";

        if (index < headers.length - 1) {
          const resizer = document.createElement("div");
          resizer.className = "resizer";
          Object.assign(resizer.style, {
            position: "absolute",
            top: 0,
            right: "-3px",
            bottom: 0,
            width: "6px",
            cursor: "col-resize",
            zIndex: 999,
          });

          header.appendChild(resizer);

          let startX = 0;
          let resizing = false;

          resizer.addEventListener("mousedown", e => {
            resizing = true;
            startX = e.pageX;
            document.addEventListener("mousemove", resize);
            document.addEventListener("mouseup", stop);
          });

          const resize = e => {
            if (!resizing) return;
            const newWidth = header.offsetWidth + (e.pageX - startX);
            header.style.width = `${newWidth}px`;
            startX = e.pageX;
          };

          const stop = () => {
            resizing = false;
            document.removeEventListener("mousemove", resize);
            document.removeEventListener("mouseup", stop);
          };
        }
      });
    },

    m_chgPgSize(x) {
      this.d_perPage = x;
    },

	m_numberFormat(value) {
  if (value === null || value === undefined || value === '') return ''

  // Remove commas
  let raw = value.toString().replace(/,/g, '')

  
  if (raw.endsWith('.')) {
    const intPart = raw.slice(0, -1)
    const formatted = Number(intPart).toLocaleString("en-US")
    return formatted + '.'
  }

  
  if (raw.includes('.')) {
    const [intPart, decPart] = raw.split('.')
    const formattedInt = Number(intPart).toLocaleString("en-US")
    return formattedInt + '.' + decPart
  }

  // Normal integer formatting
  const num = Number(raw)
  if (isNaN(num)) return ''
  return num.toLocaleString("en-US")
},

  m_handleAddClick() {
      this.d_competitorBids.push({
        competitorId: null,
        bidAmount: 0,
        bidPosition: null,
        winningBid: "No",
        removed: false,
      });
    },

    m_handleRemoveClick(index) {
      const row = this.d_competitorBids[index];

      if (row.d_competitorBidsId) {
        row.removed = true;
		this.d_changed=true;
      } else {
        this.d_competitorBids.splice(index, 1);
      }
    },

    m_saveRows() {
      const msg = fn_checkInvalid(this);
      if (msg) {
        kbdpAlert.showErr(msg);
        return;
      }

		
      let competitorBids = this.d_competitorBids.filter(b => b.removed !== true);

	const params = {
		opportunityId:this.p_recData.opportunityId,
        recordData: JSON.stringify(competitorBids)
      };

      fn_saveCompetitorBids(params).then(resp => {
        if (resp.error) {
          kbdpAlert.showErr("Unable to save Competitor Bids");
          return;
        }
        kbdpAlert.showOk("Competitor Bids saved successfully");
      });
	  
	
	  this.$set(this.vcrec.d_recData, "competitorBids", [...competitorBids]);
	  
	  this.m_initialData();
	  window.sessionStorage.removeItem('unsaved-changes');

    },

    m_initialData() {
		this.d_initialCompetitorBids = JSON.parse(JSON.stringify(this.d_competitorBids))
	},


  },
};
function fn_checkInvalid(vc) {
  for (let i = 0; i < vc.d_competitorBids.length; i++) {
    const cb = vc.d_competitorBids[i];
    const invalid = [];

    if (!cb.competitorId) invalid.push("Competitor");
    if (cb.bidAmount == null || cb.bidAmount < 0) invalid.push("Bid Amount");
    if (!cb.bidPosition) invalid.push("Bid Position");

    if (invalid.length) {
      return `For row ${i + 1}, please enter valid values for:\n"${invalid.join(
        '"\n"'
      )}"`;
    }
  }
  return null;
}
</script>
<style scoped lang="scss">
label {
  font-weight: 600 !important;
}
*:focus {
  box-shadow: none !important;
  outline: none !important;
}

.input-group-text {
  height: 100% !important;
  border-radius: 0.375rem 0px 0px 0.375rem !important;
}
.b-icon.bi {
  color: #ffc107 !important;
}
.table td {
  border: none !important;
}

.small-td {
  width: 100px !important;
}
.large-td {
  width: 300px !important;
}

p {
  margin-left: 20px !important;
  color: #42b983 !important;
  font-weight: 600 !important;
}

.input-group {
  width: 150px !important;
}
.team-member-item1 {
  width: 150px !important;

  .multiselect {
    min-height: 38px !important;
    max-height: 100% !important;
    width: 150px !important;
.multiselect__tags {
      height: 30px !important;
      border-radius: 0px !important;
    }
  }
}
.person-fill {
  height: 43px;
}

.project-cost-heading {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.btn-save{
		color:#008000;
		border:none;
		margin-left: 0.1em;;
		margin-right: 0.1em;
}
.btn-add{
		border:none;
		margin-left: 0.1em;;
		margin-right: 0.1em;
}
.tableHeader{
			background-color: #6c757d;
			color: #fff;
}
.cost1{width:50px;}
.teamMemberName1{width: 100px;}
.startDate1{width: 100px;}
.endDate1{width: 100px;}
.role1{width: 100px;}
.resizer {
		position: absolute;
		top: 0em;
		bottom: 0em;
		right: -0.5em;
		width: 1em;
		z-index: 100;
		user-select: none;
		&:hover {
			cursor: ew-resize;
				}
}
.resizing {
	border-right-color: #fff;
	> span.resizer {
		width: 20em;
		right: -10em;
		height: 20em;
		}
}
thead,th {
     border-right: 0.1em solid #adb5bd;
	}
.btn-bar {
	margin-bottom: 1em;
}
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  //1px solid black;
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;    //1px solid #428bca;
  box-shadow: none;
}
</style>
